/* RS Garage search ranking.
   House-brand products are pinned ahead of everyone else.
   A query that names a part is limited to that Shopify product type so
   "crankshaft" does not also return main bearings, pulleys, and camshafts. */
(function () {
  const RSG_PARTS = [
    {
      type: 'Blow Off Valves',
      phrases: ['blow off valves', 'blow off valve', 'blowoff valve', 'bov'],
      strong: ['blow off', 'blowoff', 'bov'],
    },
    {
      type: 'Camshafts',
      phrases: ['camshafts', 'camshaft', 'cams'],
      strong: ['camshaft', 'cam shaft'],
    },
    {
      type: 'Clutches',
      phrases: ['clutches', 'clutch'],
      strong: ['clutch'],
    },
    {
      type: 'Connecting Rods',
      phrases: ['connecting rods', 'connecting rod', 'conrods', 'conrod'],
      strong: ['connecting rod', 'conrod'],
    },
    {
      type: 'Crankshafts',
      phrases: ['crankshafts', 'crankshaft', 'crank shafts', 'crank shaft', 'cranks', 'crank'],
      strong: ['crankshaft', 'crank shaft'],
    },
    {
      type: 'Flywheels',
      phrases: ['flywheels', 'flywheel'],
      strong: ['flywheel'],
    },
    {
      type: 'Gaskets',
      phrases: ['gaskets', 'gasket'],
      strong: ['gasket'],
    },
    {
      type: 'Injectors',
      phrases: ['fuel injectors', 'fuel injector', 'injectors', 'injector'],
      strong: ['injector'],
    },
    {
      type: 'Main Bearings',
      phrases: ['main bearings', 'main bearing', 'mains'],
      strong: ['main bearing'],
    },
    {
      type: 'Pistons',
      phrases: ['pistons', 'piston'],
      strong: ['piston'],
    },
    {
      type: 'Rod Bearings',
      phrases: ['rod bearings', 'rod bearing'],
      strong: ['rod bearing'],
    },
    {
      type: 'Turbochargers',
      phrases: ['turbochargers', 'turbocharger', 'turbos', 'turbo'],
      strong: ['turbo'],
    },
    {
      type: 'Valve Covers',
      phrases: ['valve covers', 'valve cover'],
      strong: ['valve cover'],
    },
    {
      type: '',
      phrases: [
        'crank pulley',
        'crank pulleys',
        'crank damper',
        'crank dampener',
        'harmonic balancer',
        'valve spring',
        'valve springs',
        'valve seal',
        'valve seals',
        'valve guide',
        'valve guides',
        'valve lock',
        'valve locks',
        'piston ring',
        'piston rings',
        'piston pin',
        'turbo blanket',
        'turbo kit',
        'turbo kits',
        'turbo manifold',
        'head gasket',
        'valve cover gasket',
        'clutch kit',
        'clutch kits',
      ],
      strong: [],
    },
  ];

  const STOP = new Set(['for', 'the', 'and', 'with', 'oem', 'rsg']);
  const pinHtmlCache = new Map();
  const ladderHtmlCache = new Map();
  let pinToken = 0;

  /* First match wins. Edit this list to change who follows RS Garage. */
  const RSG_VENDOR_LADDER = [
    ['rsgarage'],
    ['briancrower'],
    ['manley', 'manleyperformance'],
    ['cpcarrillo', 'carrillorods', 'carrillo'],
    ['boostline'],
    ['kelford', 'kelfordcams'],
    ['ferrea'],
    ['supertech'],
    ['arp'],
    ['wiseco'],
    ['arias'],
    ['motec'],
  ];

  function rsgNormalizeQuery(value) {
    return String(value || '')
      .replace(/\s*product_type:"[^"]*"/gi, ' ')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function rsgMatchPart(raw) {
    const human = rsgNormalizeQuery(raw);
    if (!human) return null;
    const padded = ` ${human} `;
    let winner = null;
    RSG_PARTS.forEach((part) => {
      part.phrases.forEach((phrase) => {
        if (!padded.includes(` ${phrase} `)) return;
        if (!winner || phrase.length > winner.phrase.length) winner = { part, phrase };
      });
    });
    if (!winner) return null;
    return {
      type: winner.part.type || '',
      part: winner.part,
      phrase: winner.phrase,
      human,
    };
  }

  function rsgLooksLikePartNumber(value) {
    const text = String(value || '').trim();
    if (!text || /\s/.test(text)) return false;
    return /[0-9]/.test(text) || text.includes('-');
  }

  function rsgRewriteQuery(raw) {
    const human = String(raw || '')
      .replace(/\s*product_type:"[^"]*"/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    if (rsgLooksLikePartNumber(human)) return { human, submitted: human, match: null };
    const match = rsgMatchPart(human);
    if (!match || !match.type) return { human, submitted: human, match };
    return {
      human,
      submitted: `${human} product_type:"${match.type}"`.replace(/\s+/g, ' ').trim(),
      match,
    };
  }

  function rsgNormalizeVendor(vendor) {
    return String(vendor || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function rsgVendorTier(vendor) {
    const key = rsgNormalizeVendor(vendor);
    if (!key) return 100;
    for (let i = 0; i < RSG_VENDOR_LADDER.length; i += 1) {
      if (RSG_VENDOR_LADDER[i].indexOf(key) !== -1) return i;
    }
    return 100;
  }

  function rsgIsHouseVendor(vendor) {
    return rsgNormalizeVendor(vendor) === 'rsgarage';
  }

  function rsgHouseTitleOk(title, match, human) {
    const norm = rsgNormalizeQuery(title);
    if (match && match.type && match.part && match.part.strong && match.part.strong.length) {
      return match.part.strong.some((phrase) => norm.includes(phrase));
    }
    const tokens = rsgNormalizeQuery(human)
      .split(' ')
      .filter((token) => token.length >= 3 && !STOP.has(token));
    if (!tokens.length) {
      const compact = rsgNormalizeQuery(human).replace(/\s/g, '');
      return compact === 'rsg' || compact === 'rsgarage' || rsgNormalizeQuery(human) === 'rs garage';
    }
    return tokens.every((token) => {
      if (norm.includes(token)) return true;
      if (token.endsWith('s') && norm.includes(token.slice(0, -1))) return true;
      return norm.includes(`${token}s`);
    });
  }

  function rsgSearchRelevanceScore(sku, vendor, title, tokens) {
    const skuNorm = String(sku || '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
    const vendorNorm = String(vendor || '').toLowerCase();
    const titleNorm = String(title || '').toLowerCase();
    let score = 0;
    const list = tokens || [];

    list.forEach((token) => {
      const compact = token.replace(/[^a-z0-9]/g, '');
      if (!compact || compact === 'product' || compact === 'type') return;

      let hit = false;
      if (skuNorm === compact) {
        score += 200;
        hit = true;
      } else if (compact !== 'rsg' && compact.length >= 3 && skuNorm.startsWith(compact)) {
        score += 120;
        hit = true;
      } else if (compact !== 'rsg' && compact.length >= 3 && skuNorm.includes(compact)) {
        score += 70;
        hit = true;
      }

      if (vendorNorm.includes(token) || vendorNorm.replace(/[^a-z0-9]/g, '') === compact) {
        score += 25;
        hit = true;
      }
      if (titleNorm.includes(token)) {
        score += 12;
        hit = true;
      }
      if (!hit && compact.length >= 4) score -= 50;
    });

    const human = list.join(' ');
    const match = rsgMatchPart(human);
    const tier = rsgVendorTier(vendor);
    if (tier === 0 && rsgHouseTitleOk(title, match, human)) score += 100000;
    else if (tier < 100) score += (100 - tier) * 1000;

    if (match && match.type === 'Valve Covers' && !rsgIsHouseVendor(vendor)) {
      if (/\b(fitting|grommet|hardware|gasket)\b/i.test(titleNorm) && !/\b(fitting|grommet|hardware|gasket)\b/.test(human)) {
        score -= 140;
      }
    }
    if (match && match.type === 'Crankshafts' && !rsgIsHouseVendor(vendor)) {
      if (/\b(bearing|bearings|pulley|pulleys|spacer|assembly|assemblies)\b/i.test(titleNorm)) score -= 140;
    }

    return score;
  }

  function rsgSearchUrl() {
    const predictive = window.routes && window.routes.predictive_search_url;
    if (predictive) return predictive.replace(/\/suggest\/?$/, '');
    return '/search';
  }

  function rsgFetchPinHtml(human, signal) {
    const key = human.toLowerCase();
    if (pinHtmlCache.has(key)) return Promise.resolve(pinHtmlCache.get(key));
    const pinQuery = /\brs\s*garage\b/i.test(human) ? human : `RS Garage ${human}`;
    const url =
      `${rsgSearchUrl()}?q=${encodeURIComponent(pinQuery)}` +
      '&type=product&options%5Bprefix%5D=last' +
      `&filter.p.vendor=${encodeURIComponent('RS Garage')}` +
      '&sections=rsg-search-pin';
    return fetch(url, { signal, credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.json();
      })
      .then((json) => {
        const html = json['rsg-search-pin'] || '';
        pinHtmlCache.set(key, html);
        return html;
      });
  }

  function rsgFilterPinNodes(nodes, human) {
    const match = rsgMatchPart(human);
    return nodes
      .filter((node) => rsgIsHouseVendor(node.getAttribute('data-rsg-vendor')) && rsgHouseTitleOk(node.getAttribute('data-rsg-title'), match, human))
      .slice(0, 8);
  }

  function rsgApplyPins(list, nodes, prepend) {
    if (!list || !nodes.length) return;
    const handles = new Set(nodes.map((node) => node.getAttribute('data-rsg-handle')).filter(Boolean));
    list.querySelectorAll('[data-rsg-handle]').forEach((item) => {
      const handle = item.getAttribute('data-rsg-handle');
      if (item.hasAttribute('data-rsg-pinned') || (handle && handles.has(handle))) item.remove();
    });
    if (!prepend) return;
    const fragment = document.createDocumentFragment();
    nodes.forEach((node) => {
      node.setAttribute('data-rsg-pinned', 'true');
      fragment.appendChild(node);
    });
    list.insertBefore(fragment, list.firstChild);
  }

  function rsgRerankGrid() {
    const list = document.querySelector('#product-grid ul.product-grid');
    if (!list) return;
    const params = new URLSearchParams(window.location.search);
    const tokens = rsgNormalizeQuery(params.get('q') || '').match(/[a-z0-9]+/g);
    if (!tokens || tokens.length < 1) return;
    const items = Array.from(list.children).filter((item) => item.hasAttribute('data-rsg-sku') || item.hasAttribute('data-rsg-title'));
    if (items.length < 2) return;
    const scored = items.map((item, index) => ({
      item,
      index,
      score: rsgSearchRelevanceScore(
        item.getAttribute('data-rsg-sku'),
        item.getAttribute('data-rsg-vendor'),
        item.getAttribute('data-rsg-title'),
        tokens
      ),
    }));
    scored.sort((a, b) => b.score - a.score || a.index - b.index);
    scored.forEach(({ item }) => list.appendChild(item));
  }

  function rsgPinResultsGrid() {
    const params = new URLSearchParams(window.location.search);
    const human = rsgRewriteQuery(params.get('q') || '').human;
    if (!human || !document.querySelector('#product-grid')) return;
    const token = ++pinToken;
    const search = window.location.search;
    const page = Number(params.get('page') || '1');
    rsgFetchPinHtml(human)
      .then((html) => {
        if (token !== pinToken || window.location.search !== search) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cards = rsgFilterPinNodes(Array.from(doc.querySelectorAll('[data-rsg-pin-card]')), human);
        const list = document.querySelector('#product-grid ul.product-grid');
        if (!list) return;
        rsgApplyPins(list, cards, page <= 1);
      })
      .catch(() => {});
  }

  function rsgEnsurePredictiveList(root) {
    let list = root.querySelector('#predictive-search-results-products-list');
    if (list) return list;
    const results = root.querySelector('#predictive-search-results') || root;
    const group = document.createElement('div');
    group.className = 'predictive-search__result-group';
    group.innerHTML =
      '<div><h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing">Products</h2>' +
      '<ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-products"></ul></div>';
    const anchor = results.querySelector('.predictive-search__search-for-button, [data-predictive-search-search-for-text]');
    if (anchor && anchor.parentElement) {
      results.insertBefore(group, anchor.parentElement.closest('div') || anchor);
    } else {
      results.appendChild(group);
    }
    return group.querySelector('ul');
  }

  function rsgPinPredictive(instance) {
    if (!instance || !instance.predictiveSearchResults) return;
    const human = rsgRewriteQuery(instance.searchTerm || instance.getQuery() || '').human;
    if (!human) return;
    const term = instance.searchTerm;
    rsgFetchPinHtml(human, instance.abortController && instance.abortController.signal)
      .then((html) => {
        if (instance.searchTerm !== term) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const rows = rsgFilterPinNodes(Array.from(doc.querySelectorAll('[data-rsg-pin-row]')), human);
        if (!rows.length) return;
        const list = rsgEnsurePredictiveList(instance.predictiveSearchResults);
        rsgApplyPins(list, rows, true);
      })
      .catch(() => {});
  }

  function rsgMaybeTightenSearchUrl() {
    if (!document.getElementById('product-grid') && !document.querySelector('.template-search')) return false;
    const params = new URLSearchParams(window.location.search);
    const raw = params.get('q') || '';
    if (!raw || /product_type:"/i.test(raw)) return false;
    const rewritten = rsgRewriteQuery(raw);
    if (!rewritten.match || !rewritten.match.type || rewritten.submitted === raw) return false;
    params.set('q', rewritten.submitted);
    window.location.replace(`${window.location.pathname}?${params.toString()}`);
    return true;
  }

  function rsgOnSearchSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input) return;
    if (form.querySelector('[aria-selected="true"] a, button[aria-selected="true"]')) return;
    const rewritten = rsgRewriteQuery(input.value);
    if (!rewritten.match || !rewritten.match.type || rewritten.submitted === rewritten.human) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const params = new URLSearchParams(new FormData(form));
    params.set('q', rewritten.submitted);
    const action = form.getAttribute('action') || rsgSearchUrl();
    window.location.assign(`${action}?${params.toString()}`);
  }

  function rsgCleanSearchChrome() {
    document.querySelectorAll('input[type="search"][name="q"]').forEach((input) => {
      const human = rsgRewriteQuery(input.value).human;
      if (human && human !== input.value) input.value = human;
    });
    if (/product_type:/i.test(document.title)) {
      document.title = document.title.replace(/\s*product_type:"[^"]*"/gi, '').replace(/""/g, '"');
    }
  }

  function rsgProductList() {
    const grid = document.getElementById('product-grid');
    if (!grid) return null;
    if (grid.tagName === 'UL') return grid;
    return grid.querySelector('ul.product-grid');
  }

  function rsgLadderEnabled() {
    const sort = new URLSearchParams(window.location.search).get('sort_by') || '';
    return !/^(price|title|created)/.test(sort);
  }

  function rsgSortListByVendor(list) {
    if (!list) return;
    const tokens = rsgNormalizeQuery(new URLSearchParams(window.location.search).get('q') || '').match(/[a-z0-9]+/g);
    const ranked = Array.from(list.children).map((item, index) => ({
      item,
      index,
      tier: rsgVendorTier(item.getAttribute('data-rsg-vendor')),
      score: tokens
        ? rsgSearchRelevanceScore(
            item.getAttribute('data-rsg-sku'),
            item.getAttribute('data-rsg-vendor'),
            item.getAttribute('data-rsg-title'),
            tokens
          )
        : 0,
    }));
    ranked.sort((a, b) => a.tier - b.tier || b.score - a.score || a.index - b.index);
    ranked.forEach(({ item }) => list.appendChild(item));
  }

  function rsgLadderVendorNames() {
    const checked = document.querySelectorAll('input[name="filter.p.vendor"]:checked');
    if (checked.length) return [];
    const seen = new Set();
    const names = [];
    document.querySelectorAll('input[name="filter.p.vendor"]').forEach((input) => {
      const name = input.value;
      if (!name || seen.has(name) || rsgVendorTier(name) === 100) return;
      seen.add(name);
      names.push(name);
    });
    names.sort((a, b) => rsgVendorTier(a) - rsgVendorTier(b));
    return names;
  }

  function rsgFetchVendorSection(vendorName, signal) {
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.set('filter.p.vendor', vendorName);
    url.searchParams.set('sections', 'rsg-vendor-pin');
    const key = `${url.pathname}?${url.searchParams.toString()}`;
    if (ladderHtmlCache.has(key)) return Promise.resolve(ladderHtmlCache.get(key));
    return fetch(url.toString(), { signal, credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.json();
      })
      .then((json) => {
        const html = json['rsg-vendor-pin'] || '';
        ladderHtmlCache.set(key, html);
        return html;
      });
  }

  function rsgRefreshGridOrder() {
    if (!rsgLadderEnabled()) return;
    const list = rsgProductList();
    if (!list) return;
    rsgSortListByVendor(list);

    const params = new URLSearchParams(window.location.search);
    const human = rsgRewriteQuery(params.get('q') || '').human;
    const onSearch = window.location.pathname.indexOf('/search') !== -1;
    const vendors = rsgLadderVendorNames().filter((name) => !(onSearch && human && rsgIsHouseVendor(name)));
    const jobs = vendors.map((name) =>
      rsgFetchVendorSection(name)
        .then((html) => ({ name, html, house: false }))
        .catch(() => ({ name, html: '', house: false }))
    );
    if (onSearch && human) {
      jobs.unshift(
        rsgFetchPinHtml(human)
          .then((html) => ({ name: 'RS Garage', html, house: true }))
          .catch(() => ({ name: 'RS Garage', html: '', house: true }))
      );
    }
    if (!jobs.length) return;

    const token = ++pinToken;
    const search = window.location.search;
    const page = Number(params.get('page') || '1');
    Promise.all(jobs).then((groups) => {
      if (token !== pinToken || window.location.search !== search) return;
      const listNow = rsgProductList();
      if (!listNow) return;
      const cards = [];
      groups
        .sort((a, b) => rsgVendorTier(a.name) - rsgVendorTier(b.name))
        .forEach((group) => {
          if (!group.html) return;
          const doc = new DOMParser().parseFromString(group.html, 'text/html');
          let nodes = Array.from(doc.querySelectorAll('[data-rsg-pin-card]'));
          if (group.house) nodes = rsgFilterPinNodes(nodes, human);
          nodes.forEach((node) => cards.push(node));
        });
      if (!cards.length) return;
      rsgApplyPins(listNow, cards, page <= 1);
      rsgSortListByVendor(listNow);
    });
  }

  document.addEventListener('submit', rsgOnSearchSubmit, true);

  document.addEventListener('DOMContentLoaded', () => {
    rsgCleanSearchChrome();
    if (rsgMaybeTightenSearchUrl()) return;
    rsgRefreshGridOrder();
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;
    const observer = new MutationObserver(() => {
      rsgRefreshGridOrder();
    });
    observer.observe(container, { childList: true });
  });

  window.rsgRewriteQuery = rsgRewriteQuery;
  window.rsgSearchRelevanceScore = rsgSearchRelevanceScore;
  window.rsgPinPredictive = rsgPinPredictive;
})();
